function getAPIroot(){
    let root = localStorage.getItem('APIROOT');
    if(root){
        return root
    }
    return process.env.REACT_APP_API_ROOT ? process.env.REACT_APP_API_ROOT : 'http://localhost';
}

const urls = {
    API_ROOT: getAPIroot(),
    SSO_URL: process.env.REACT_APP_SSO_ROOT
};

export default urls;



// WEBPACK FOOTER //
// ./src/utils/urls.js